import { render, staticRenderFns } from "./PopupInstructions.vue?vue&type=template&id=92f5c360"
import script from "./PopupInstructions.vue?vue&type=script&lang=js"
export * from "./PopupInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports